import { useModalStore } from '../../stores/modal.store';
import { NewClientModal } from './NewClientModal';
import { NewProjectFlow } from './NewProjectFlow';
import { NewInvoiceFlow } from './NewInvoiceFlow';
import { NewQuoteFlow } from './NewQuoteFlow';
import { NewServiceModal } from './NewServiceModal';
import { AttachSubscriptionModal } from './AttachSubscriptionModal';
import { NewTaskModal } from './NewTaskModal';
import { NewDealModal } from './NewDealModal';
import { NewVendorModal } from './NewVendorModal';
import { NewCourseModal } from './NewCourseModal';
import { NewCandidateModal } from './NewCandidateModal';
import { NewBodyRentalRequestModal } from './NewBodyRentalRequestModal';
import { AddCourseCandidateModal } from './AddCourseCandidateModal';
import { NewVaultModal } from './NewVaultModal';
import { NewSALModal } from './NewSALModal';
import { UploadDocModal } from './UploadDocModal';
import { AssignResourceModal } from './AssignResourceModal';
import { NewRoleModal } from './NewRoleModal';
import { NewDeliverableModal } from './NewDeliverableModal';
import { TaskDetailModal } from './TaskDetailModal';
import { NewCommModal } from './NewCommModal';
import { NewMilestoneModal } from './NewMilestoneModal';
import { NewClientNoteModal } from './NewClientNoteModal';
import { NewContactModal } from './NewContactModal';
import { NewLessonModal } from './NewLessonModal';
import { NewAssessmentModal } from './NewAssessmentModal';
import { NewUserModal } from './NewUserModal';
import { PasswordModal } from './PasswordModal';
import { NewIntegrationModal } from './NewIntegrationModal';
import { ExportModal } from './ExportModal';
import { NewCashEntryModal } from './NewCashEntryModal';
import { NewRecurringModal } from './NewRecurringModal';
import { NewTaxModal } from './NewTaxModal';
import { NewPayableModal } from './NewPayableModal';
import { NewEmployeeModal, type SchedaPersonaMode } from './NewEmployeeModal';
import type { RecurringDaModificare } from './NewRecurringModal';
import type { Persona } from '../../features/admin/dipendenti/dipendentiApi';

export function ModalsRoot() {
  const { kind, payload, close } = useModalStore();
  if (!kind) return null;
  switch (kind) {
    case 'newClient':      return <NewClientModal onClose={close} clientId={payload?.clientId as string | undefined} />;
    case 'newProject':     return <NewProjectFlow onClose={close} clientId={payload?.clientId as string | undefined} division={payload?.division as any} />;
    case 'newInvoice':     return <NewInvoiceFlow onClose={close}
                                    clientId={payload?.clientId as string | undefined}
                                    projectId={payload?.projectId as string | undefined}
                                    type={payload?.type as any} />;
    case 'newQuote':       return <NewQuoteFlow onClose={close}
                                    clientId={payload?.clientId as string | undefined}
                                    projectId={payload?.projectId as string | undefined}
                                    initialLines={payload?.lines as any}
                                    initialTitle={payload?.title as string | undefined} />;
    case 'newService':     return <NewServiceModal onClose={close} />;
    case 'attachSubscription': return <AttachSubscriptionModal onClose={close}
                                    clientId={payload?.clientId as string | undefined}
                                    clientName={payload?.clientName as string | undefined} />;
    // Una proposta nuova dell'Assistente monta una finestra nuova: con la finestra già aperta,
    // gli stati di prima nasconderebbero la proposta e terrebbero la partenza sbagliata (28/10/2026).
    case 'newTask':        return <NewTaskModal key={(payload?.prefill as any)?.proposta?.aiActionId ?? 'nuovo'} onClose={close}
                                    projectId={payload?.projectId as string | undefined}
                                    prefill={payload?.prefill as any} />;
    case 'newDeal':        return <NewDealModal onClose={close} pipeline={payload?.pipeline as string | undefined} />;
    case 'newVendor':      return <NewVendorModal onClose={close} />;
    case 'newCourse':      return <NewCourseModal onClose={close} />;
    case 'newCandidate':   return <NewCandidateModal onClose={close} />;
    case 'newBodyRental':  return <NewBodyRentalRequestModal onClose={close} clientId={payload?.clientId as string | undefined} />;
    case 'addCourseCandidate': return <AddCourseCandidateModal onClose={close} courseId={payload?.courseId as string} stage={payload?.stage as string | undefined} />;
    case 'newVault':       return <NewVaultModal onClose={close} />;
    case 'newSAL':         return <NewSALModal onClose={close} projectId={payload?.projectId as string | undefined} />;
    case 'uploadDoc':      return <UploadDocModal onClose={close}
                                    scope={(payload?.scope as any) ?? 'project'}
                                    scopeId={payload?.scopeId as string} />;
    case 'assignMember':   return <AssignResourceModal onClose={close} projectId={payload?.projectId as string} />;
    case 'newRole':        return <NewRoleModal onClose={close} />;
    case 'newDeliverable': return <NewDeliverableModal onClose={close} projectId={payload?.projectId as string | undefined} />;
    case 'taskDetail':     return <TaskDetailModal onClose={close} taskId={payload?.taskId as string} />;
    case 'newComm':        return <NewCommModal onClose={close}
                                    projectId={payload?.projectId as string | undefined}
                                    clientId={payload?.clientId as string | undefined}
                                    prefill={payload?.prefill as any} />;
    case 'newMilestone':   return <NewMilestoneModal onClose={close} projectId={payload?.projectId as string} />;
    case 'newClientNote':  return <NewClientNoteModal onClose={close} clientId={payload?.clientId as string} />;
    case 'newContact':     return <NewContactModal onClose={close}
                                    clientId={payload?.clientId as string}
                                    contact={payload?.contact as any} />;
    case 'newLesson':      return <NewLessonModal onClose={close} courseId={payload?.courseId as string} />;
    case 'newAssessment':  return <NewAssessmentModal onClose={close} courseId={payload?.courseId as string} />;
    case 'newUser':        return <NewUserModal onClose={close} user={payload?.user as any} />;
    case 'password':       return <PasswordModal onClose={close} userId={payload?.userId as string} userName={payload?.userName as string | undefined} mode={(payload?.mode as 'self' | 'admin') ?? 'self'} />;
    case 'newIntegration': return <NewIntegrationModal onClose={close} />;
    case 'export':         return <ExportModal onClose={close} what={(payload?.what as string) ?? 'Dati'} period={payload?.period as any} />;
    case 'newCashEntry':   return <NewCashEntryModal onClose={close} direction={(payload?.direction as 'IN' | 'OUT') ?? 'IN'} />;
    // Con `recurring` è la modifica di una spesa fissa (Spese › Spese fisse): senza, la creazione.
    case 'newRecurring':   return <NewRecurringModal onClose={close} recurring={payload?.recurring as RecurringDaModificare | undefined} />;
    case 'newTax':         return <NewTaxModal onClose={close} tax={payload?.tax as any} prefill={payload?.prefill as any} />;
    case 'newPayable':     return <NewPayableModal onClose={close} />;
    // Scheda di una persona in busta paga (Amministrazione › Dipendenti): nuova, modifica o fine del rapporto.
    case 'newEmployee':    return <NewEmployeeModal onClose={close} employee={payload?.employee as Persona | undefined} mode={payload?.mode as SchedaPersonaMode | undefined} />;
    default: return null;
  }
}
